import { useEffect, useRef } from 'react'
import { Input } from 'reactstrap'

import type { ChangeEvent } from 'react'

type Props = {
  id: string
  checked: boolean
  onClick?: (checked: boolean) => void
  indeterminate?: boolean
  disabled?: boolean
}

export const TableCheckbox = ({ id, checked, onClick, indeterminate = false, disabled }: Props) => {
  const checkboxRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (checkboxRef?.current) {
      checkboxRef.current.indeterminate = indeterminate
    }
  }, [checkboxRef, indeterminate])

  const handleClick = (event: ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation()
    onClick?.(event.target.checked)
  }

  return (
    <Input
      id={id}
      className="mt-0"
      innerRef={checkboxRef}
      type="checkbox"
      checked={checked}
      onChange={handleClick}
      disabled={disabled}
    />
  )
}
export default TableCheckbox
